"use client";
import { jsx as e } from "react/jsx-runtime";
import * as r from "@radix-ui/react-dropdown-menu";
import { forwardRef as d, isValidElement as s } from "react";
import { appendToChildren as w } from "../../../utils/appendToChildren.mjs";
import { DEFAULT_ICON_CLASS_NAME as u } from "../../../utils/iconDefaults.mjs";
import { Check as l, ChevronRight as c } from "../Icon/icons.gen.mjs";
import { Text as D } from "../Text/Text.mjs";
const _ = (o) => /* @__PURE__ */ e(r.Root, { "data-slot": "dropdown-menu", ...o }), M = d((o, n) => /* @__PURE__ */ e(r.Trigger, { "data-slot": "dropdown-menu-trigger", ...o, ref: n }));
M.displayName = "DropdownMenuTrigger";
const i = (o) => /* @__PURE__ */ e(r.Portal, { "data-slot": "dropdown-menu-portal", ...o }), b = d((o, n) => /* @__PURE__ */ e(i, { children: /* @__PURE__ */ e(r.Content, { "data-slot": "dropdown-menu-content", ...o, ref: n }) }));
b.displayName = "DropdownMenuContent";
const g = d((o, n) => /* @__PURE__ */ e(r.Group, { "data-slot": "dropdown-menu-group", ...o, ref: n }));
g.displayName = "DropdownMenuGroup";
const N = d(
  ({ children: o, fontSize: n = "sm", fontWeight: t = "semibold", fontFamily: a = "inter", ...p }, m) => /* @__PURE__ */ e(r.Label, { "data-slot": "dropdown-menu-label", ...p, ref: m, children: /* @__PURE__ */ e(D, { asChild: !0, fontSize: n, fontWeight: t, fontFamily: a, children: s(o) ? o : /* @__PURE__ */ e("span", { children: o }) }) })
);
N.displayName = "DropdownMenuLabel";
const I = d((o, n) => /* @__PURE__ */ e(r.Item, { "data-slot": "dropdown-menu-item", ...o, ref: n }));
I.displayName = "DropdownMenuItem";
const h = d((o, n) => /* @__PURE__ */ e(r.CheckboxItem, { "data-slot": "dropdown-menu-checkbox-item", ...o, ref: n }));
h.displayName = "DropdownMenuCheckboxItem";
const C = d((o, n) => /* @__PURE__ */ e(r.RadioGroup, { "data-slot": "dropdown-menu-radio-group", ...o, ref: n }));
C.displayName = "DropdownMenuRadioGroup";
const y = d((o, n) => /* @__PURE__ */ e(r.RadioItem, { "data-slot": "dropdown-menu-radio-item", ...o, ref: n }));
y.displayName = "DropdownMenuRadioItem";
const S = d(
  ({ children: o, ...n }, t) => /* @__PURE__ */ e(r.ItemIndicator, { "data-slot": "dropdown-menu-item-indicator", ...n, ref: t, children: o ?? /* @__PURE__ */ e(l, { "data-slot": "dropdown-menu-check-icon", "aria-hidden": "true", className: u }) })
);
S.displayName = "DropdownMenuItemIndicator";
const R = d((o, n) => /* @__PURE__ */ e(r.Separator, { "data-slot": "dropdown-menu-separator", ...o, ref: n }));
R.displayName = "DropdownMenuSeparator";
const v = (o) => /* @__PURE__ */ e(r.Sub, { "data-slot": "dropdown-menu-sub", ...o }), f = d(
  ({
    children: o,
    icon: n = /* @__PURE__ */ e(
      c,
      {
        "data-slot": "dropdown-menu-sub-trigger-icon",
        "aria-hidden": "true",
        className: u
      }
    ),
    asChild: t,
    ...a
  }, p) => /* @__PURE__ */ e(r.SubTrigger, { "data-slot": "dropdown-menu-sub-trigger", asChild: t, ...a, ref: p, children: w(o, n, t) })
);
f.displayName = "DropdownMenuSubTrigger";
const T = d((o, n) => /* @__PURE__ */ e(i, { children: /* @__PURE__ */ e(r.SubContent, { "data-slot": "dropdown-menu-sub-content", ...o, ref: n }) }));
T.displayName = "DropdownMenuSubContent";
const x = d((o, n) => /* @__PURE__ */ e(r.Arrow, { "data-slot": "dropdown-menu-arrow", ...o, ref: n }));
x.displayName = "DropdownMenuArrow";
export {
  x as DropdownMenuArrow,
  h as DropdownMenuCheckboxItem,
  b as DropdownMenuContent,
  g as DropdownMenuGroup,
  I as DropdownMenuItem,
  S as DropdownMenuItemIndicator,
  N as DropdownMenuLabel,
  i as DropdownMenuPortal,
  C as DropdownMenuRadioGroup,
  y as DropdownMenuRadioItem,
  _ as DropdownMenuRoot,
  R as DropdownMenuSeparator,
  v as DropdownMenuSub,
  T as DropdownMenuSubContent,
  f as DropdownMenuSubTrigger,
  M as DropdownMenuTrigger
};
